(function () {
  angular.module('status-app', ['app.config.core', 'templates']);
})();
